<template>
  <div id="app">
    <FaceVerify />
  </div>
</template>

<script>
import FaceVerify from './components/FaceVerify.vue'

export default {
  name: 'App',
  components: {
    FaceVerify
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
